import dataHelper from "./src";
export default dataHelper;